export default class LpVariant {
  
  constructor() {
    if (this.setVars()) {
      this.setEvents();
    }
  }
  
  setVars() {
    
    this.settings = {
      'init': 'data-lp-variant',
      'selected': 'data-lp-variant-selected',
      'left': 'data-lp-variant-left',
      'right': 'data-lp-variant-right',
      'choose': 'data-lp-variant-choose',
    };
    
    this.variants = [];
    this.current = 0;
    
    this.lpVariant = document.querySelector(`[${this.settings.init}]`);
    if (!this.lpVariant) return;
    
    return true;
  }
  
  setEvents() {
    this.lpVariant.querySelectorAll(`[${this.settings.choose}]`).forEach((item, index) => {
      this.variants.push(item.getAttribute(this.settings.choose));
      
      if (item.getAttribute(this.settings.choose) === this.lpVariant.querySelector(`[${this.settings.selected}]`).getAttribute(this.settings.selected)) {
        this.current = index;
      }
    });
    this.lpVariant.querySelector(`[${this.settings.left}]`).addEventListener('click', () => {
      this.lpVariant.querySelector(`[${this.settings.selected}]`).setAttribute(this.settings.selected, this.prev())
    });
    
    this.lpVariant.querySelector(`[${this.settings.right}]`).addEventListener('click', () => {
      this.lpVariant.querySelector(`[${this.settings.selected}]`).setAttribute(this.settings.selected, this.next())
    });
  }

  next() {
    if (this.current === (this.variants.length - 1)) {
      this.current = 0;
    } else {
      this.current++;
    }
  
    return this.variants[this.current];
  }
  
  prev() {
    if (this.current === 0) {
      this.current = (this.variants.length - 1);
    } else {
      this.current--;
    }
    
    return this.variants[this.current];
  }
}
